import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { ArrowLeftIcon } from '@change/ds-icons';

import { header, headerContainer, headerTitle } from '../AddEndorsement/AddEndorsement.styles';

type EndorsementFormHeaderProps = {
	onBack: () => void;
	title: string;
	backButtonAriaLabel: string;
};

export const EndorsementFormHeader: React.FC<EndorsementFormHeaderProps> = ({ onBack, title, backButtonAriaLabel }) => {
	return (
		<header className={header()} data-testid="endorsement-form-header">
			<div className={headerContainer()}>
				<Button
					variant="tertiary"
					onClick={onBack}
					aria-label={backButtonAriaLabel}
					data-testid="endorsement-form-back-button"
					data-qa="endorsement-form-back-button"
					className="-ml-4 p-4"
				>
					<ArrowLeftIcon className="text-typography-strong" size="medium" />
				</Button>
				<Text variant="heading" size="small" className={headerTitle()} as="h1">
					{title}
				</Text>
			</div>
		</header>
	);
};
